const a = {
  name: "--pf-v6-c-drawer__panel--md--FlexBasis",
  value: "50%",
  var: "var(--pf-v6-c-drawer__panel--md--FlexBasis)"
};
export {
  a as c_drawer__panel_md_FlexBasis,
  a as default
};
